import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Field } from 'redux-form';
import masterField from '../../../../../components/search-form/master-field';
import renderField from './render-field';

class AccountOpportunityField extends Component {
  constructor(props) {
    super(props);
    this.state = {
    };
    this.handleSyncDateClick = this.handleSyncDateClick.bind(this);
  }


  handleSyncDateClick(e) {
    e.stopPropagation();
    e.preventDefault();
    this.props.requestShowSyncTab();
  }

  render() {
    const { disabled, value, dateRangeLabel } = this.props;

    const options = [
      { value: true, label: `Most Recent Won Opportunity` },
      { value: false, label: `All Won Opportunities ${dateRangeLabel !== null ? dateRangeLabel : ''}` },
    ];

    let tips = null;
    if (value) {
      tips = (
        <span>Contacts associated with <strong>the most recent won opportunity</strong> will be submitted.</span>
      );
    } else {
      const anchor = dateRangeLabel !== null ? (
        <a href="" onClick={this.handleSyncDateClick}>{dateRangeLabel}</a>
      ) : null;
      tips = (
        <span>Contacts associated with <strong>all won opportunities</strong> {anchor} will be submitted.</span>
      );
    }


    return (
      <div>
        <Field
          name="full_automation_opportunty_contact_types"
          componentClass="select"
          options={options}
          component={renderField}
          disabled={disabled}
          input={{
            value,
            onChange: (e) => {
              if (e.target.value) {
                this.props.onChange(e.target.value === 'true' || e.target.value === true);
              }
            },
          }}
        />
        {tips !== null && <div><em>{tips}</em></div>}
      </div>
    );
  }
}

AccountOpportunityField.propTypes = {
  value: PropTypes.bool,
  disabled: PropTypes.bool,
  submitting: PropTypes.bool,
  onChange: PropTypes.func,
  dateRangeLabel: PropTypes.string,
  requestShowSyncTab: PropTypes.func,
};
AccountOpportunityField.defaultProps = {
  value: false,
  disabled: false,
  submitting: false,
  dateRangeLabel: null,
  onChange: () => {},
  requestShowSyncTab: () => {},
};
export default masterField(AccountOpportunityField);
